import React, { Fragment, useEffect, useState } from "react"
import PropTypes from "prop-types"
import {
  useTable,
  useGlobalFilter,
  useAsyncDebounce,
  useSortBy,
  useExpanded,
  usePagination,
} from "react-table"
import { Table, Row, Col, Button } from "reactstrap"
import JobListGlobalFilter from "./GlobalSearchFilter"
import { Link } from "react-router-dom"
import DiplomaDetailsModal from "pages/AllDiplomaList/DiplomaDetailsModal"
import UploadDiplomaDetailModal from "pages/AddDiplomaBatch/UploadDiplomaDetailModal"
import QRModal from "pages/DiplomaList/QRModal"
import { CSVLink } from "react-csv"
import Cookies from "js-cookie"

// Define a default UI for filtering
function GlobalFilter({
  preGlobalFilteredRows,
  globalFilter,
  setGlobalFilter,
  isJobListGlobalFilter,
}) {
  const count = preGlobalFilteredRows.length
  const [value, setValue] = React.useState(globalFilter)
  const onChange = useAsyncDebounce(value => {
    setGlobalFilter(value || undefined)
  }, 200)

  return (
    <React.Fragment>
      <Col md={4}>
        <div className="search-box me-xxl-2 my-3 my-xxl-0 d-inline-block">
          <div className="position-relative">
            <label htmlFor="search-bar-0" className="search-label">
              <span id="search-bar-0-label" className="sr-only">
                Хайлт хийх
              </span>
              <input
                onChange={e => {
                  setValue(e.target.value)
                  onChange(e.target.value)
                }}
                id="search-bar-0"
                type="text"
                className="form-control"
                placeholder={`${count} диплом...`}
                value={value || ""}
              />
            </label>
            <i className="bx bx-search-alt search-icon"></i>
          </div>
        </div>
      </Col>
      {isJobListGlobalFilter && (
        <JobListGlobalFilter setGlobalFilter={setGlobalFilter} />
      )}
    </React.Fragment>
  )
}

const TableContainerWithModal = ({
  isShowAll,
  isUpload,
  modalState,
  toggleViewModal,
  UploadModalState,
  UploadToggleViewModal,
  columns,
  data,
  isGlobalFilter,
  isJobListGlobalFilter,
  isAddOptions,
  isAddUserList,
  handleOrderClicks,
  handleUserClick,
  handleCustomerClick,
  isAddCustList,
  customPageSize,
  customPageSizeOptions,
  iscustomPageSizeOptions,
  isPagination,
  isShowingPageLength,
  paginationDiv,
  pagination,
  tableClass,
  theadClass,
}) => {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data,
      // defaultColumn: { Filter: DefaultColumnFilter },
      initialState: {
        pageIndex: 0,
        pageSize: customPageSize,
        sortBy: [
          {
            desc: true,
          },
        ],
      },
    },
    useGlobalFilter,
    // useFilters,
    useSortBy,
    useExpanded,
    usePagination
  )
  const generateSortingIndicator = column => {
    return column.isSorted ? (column.isSortedDesc ? " 🔽" : " 🔼") : ""
  }

  const [maxPagesToShow, setMaxPagesToShow] = useState(10)

  useEffect(() => {
    const handleResize = () => {
      setMaxPagesToShow(window.innerWidth <= 768 ? 3 : 10)
    }

    handleResize() // Set initial value
    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [])

  const onChangeInSelect = event => {
    setPageSize(Number(event.target.value))
  }
  const [modalIndex, setModalIndex] = useState(null)
  const [qrIndex, setQRIndex] = useState(null)
  const [qrModal, setQRModal] = useState(false)
  const toggleQRModal = i => {
    setQRIndex(i), setQRModal(!qrModal)
  }
  const handleToggle = i => {
    setModalIndex(i)
    if (isUpload) {
      UploadToggleViewModal()
    } else {
      toggleViewModal()
    }
  }

  const getExportData = () => {
    return data.map((row, index) => {
      // Check if row.claims is an object, if not, default to an empty object
      const claims =
        typeof row.claims === "object" && row.claims !== null ? row.claims : {}

      // Check if claims.extras is an object, if not, default to an empty object
      const extras =
        typeof claims.extras === "object" && claims.extras !== null
          ? claims.extras
          : {}

      return {
        id: row.id,
        ...claims,
        ...extras, // Adding all attributes of the extras object
        qrCode: `${process.env.REACT_APP_CHECK_HOST}/${row.id}?channel=${process.env.REACT_APP_CHANNEL_UNI}`,
      }
    })
  }

  const startPage = Math.max(
    0,
    Math.min(
      pageIndex - Math.floor(maxPagesToShow / 2),
      pageOptions.length - maxPagesToShow
    )
  )
  const endPage = Math.min(startPage + maxPagesToShow, pageOptions.length)

  return (
    <Fragment>
      <Row className="mb-2">
        {iscustomPageSizeOptions && (
          <Col md={customPageSizeOptions ? 2 : 1}>
            <select
              className="form-select"
              value={pageSize}
              onChange={onChangeInSelect}
            >
              {[10, 20, 30, 40, 50].map(pageSize => (
                <option key={pageSize} value={pageSize}>
                  {pageSize} ширхэг
                </option>
              ))}
            </select>
          </Col>
        )}

        {isGlobalFilter && (
          <GlobalFilter
            preGlobalFilteredRows={preGlobalFilteredRows}
            globalFilter={state.globalFilter}
            setGlobalFilter={setGlobalFilter}
            isJobListGlobalFilter={isJobListGlobalFilter}
          />
        )}
        {isAddOptions && (
          <Col sm="7">
            <div className="text-sm-end">
              <Button
                type="button"
                color="success"
                className="btn-rounded  mb-2 me-2"
                onClick={handleOrderClicks}
              >
                <i className="mdi mdi-plus me-1" />
                Add New Order
              </Button>
            </div>
          </Col>
        )}
        {isAddUserList && (
          <Col sm="7">
            <div className="text-sm-end">
              <Button
                type="button"
                color="primary"
                className="btn mb-2 me-2"
                onClick={handleUserClick}
              >
                <i className="mdi mdi-plus-circle-outline me-1" />
                Create New
              </Button>
            </div>
          </Col>
        )}
        {isAddCustList && (
          <Col sm="7">
            <div className="text-sm-end">
              <Button
                type="button"
                color="success"
                className="btn-rounded mb-2 me-2"
                onClick={handleCustomerClick}
              >
                <i className="mdi mdi-plus me-1" />
                New Customers
              </Button>
            </div>
          </Col>
        )}
        {!isUpload ? (
          <Col sm="7">
            <div className="text-sm-end">
              {
                <CSVLink data={getExportData()} filename={"table-data.csv"}>
                  <Button type="button" color="primary" className="">
                    Export
                  </Button>
                </CSVLink>
              }
            </div>
          </Col>
        ) : (
          <></>
        )}
      </Row>

      <div className="table-responsive">
        <QRModal index={qrIndex} isOpen={qrModal} toggle={toggleQRModal} />
        {isUpload && modalIndex !== null ? (
          <UploadDiplomaDetailModal
            data={data}
            index={modalIndex}
            isOpen={UploadModalState}
            toggle={UploadToggleViewModal}
            isShowAll={isShowAll}
          />
        ) : !isUpload && modalIndex !== null ? (
          <DiplomaDetailsModal
            data={data}
            index={modalIndex}
            isOpen={modalState}
            toggle={toggleViewModal}
          />
        ) : (
          <></>
        )}
        <Table {...getTableProps()} className={tableClass}>
          <thead className={theadClass}>
            {headerGroups.map(headerGroup => (
              <tr key={headerGroup.id} {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map(column => (
                  <th
                    key={column.id}
                    className={column.isSort ? "sorting" : ""}
                  >
                    <div className="m-0" {...column.getSortByToggleProps()}>
                      {column.render("Header")}
                    </div>
                    {/* <Filter column={column} /> */}
                  </th>
                ))}
                <th>
                  <div className="m-0">Дэлгэрэнгүй</div>
                </th>
                <th>
                  <div className="m-0">QR</div>
                </th>
              </tr>
            ))}
          </thead>

          <tbody {...getTableBodyProps()}>
            {page.map(row => {
              prepareRow(row)
              const rowId = row.original.id
              return (
                <Fragment key={row.getRowProps().key}>
                  <tr>
                    {row.cells.map(cell => {
                      return (
                        <td key={cell.id} {...cell.getCellProps()}>
                          {cell.render("Cell")}
                        </td>
                      )
                    })}
                    <td>
                      <Button
                        type="button"
                        color="primary"
                        className="btn-sm btn-rounded"
                        onClick={() => handleToggle(row.id)}
                      >
                        Дэлгэрэнгүй харах
                      </Button>
                    </td>
                    <td>
                      <Button
                        type="button"
                        color="primary"
                        className="btn-sm btn-rounded"
                        onClick={() => toggleQRModal(rowId)}
                      >
                        QR Харах
                      </Button>
                    </td>
                  </tr>
                </Fragment>
              )
            })}
          </tbody>
        </Table>
      </div>

      {isPagination && (
        <Row className="justify-content-between align-items-center">
          {isShowingPageLength && (
            <div className="col-sm">
              <div className="text-muted">
                Showing <span className="fw-semibold">{page.length}</span> of{" "}
                <span className="fw-semibold">{data.length}</span> entries
              </div>
            </div>
          )}
          <div className={paginationDiv}>
            <ul className={pagination}>
              <li className={`page-item ${!canPreviousPage ? "disabled" : ""}`}>
                <Link to="#" className="page-link" onClick={previousPage}>
                  <i className="mdi mdi-chevron-left"></i>
                </Link>
              </li>
              {startPage > 0 && (
                <li className="page-item">
                  <Link
                    to="#"
                    className="page-link"
                    onClick={() => gotoPage(0)}
                  >
                    1
                  </Link>
                </li>
              )}
              {startPage > 1 && <li className="page-item disabled">...</li>}
              {pageOptions.slice(startPage, endPage).map(item => (
                <React.Fragment key={item}>
                  <li
                    className={
                      pageIndex === item ? "page-item active" : "page-item"
                    }
                  >
                    <Link
                      to="#"
                      className="page-link"
                      onClick={() => gotoPage(item)}
                    >
                      {item + 1}
                    </Link>
                  </li>
                </React.Fragment>
              ))}
              {endPage < pageOptions.length - 1 && (
                <li className="page-item disabled">...</li>
              )}
              {endPage < pageOptions.length && (
                <li className="page-item">
                  <Link
                    to="#"
                    className="page-link"
                    onClick={() => gotoPage(pageOptions.length - 1)}
                  >
                    {pageOptions.length}
                  </Link>
                </li>
              )}
              <li className={`page-item ${!canNextPage ? "disabled" : ""}`}>
                <Link to="#" className="page-link" onClick={nextPage}>
                  <i className="mdi mdi-chevron-right"></i>
                </Link>
              </li>
            </ul>
          </div>
        </Row>
      )}
    </Fragment>
  )
}

TableContainerWithModal.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
}

export default TableContainerWithModal
